export const SET_FLOORPLAN_UNIT_ID = 'SET_FLOORPLAN_UNIT_ID';
export const SET_FLOORPLAN = 'SET_FLOORPLAN';
export const CLEAN_STATE = 'CLEAN_STATE';

export default {
    [SET_FLOORPLAN_UNIT_ID]: (state, payload) => (state.unitId = payload),
    [SET_FLOORPLAN]: (state, payload) => (state.floorplan = payload),
    [CLEAN_STATE]: state => (state.unitId = ''),
};
